import { render, staticRenderFns } from "./GroupUsers.vue?vue&type=template&id=dc124ab0"
import script from "./GroupUsers.vue?vue&type=script&lang=ts"
export * from "./GroupUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc124ab0')) {
      api.createRecord('dc124ab0', component.options)
    } else {
      api.reload('dc124ab0', component.options)
    }
    module.hot.accept("./GroupUsers.vue?vue&type=template&id=dc124ab0", function () {
      api.rerender('dc124ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/groups/GroupUsers.vue"
export default component.exports